import { echartOptionStrategies } from "./echartOptionStrategy";
import { updateOnlyStrategyResolver } from "./updateOnlyStrategy";
/**
 * Resolve qual echartOption deverá ser utilizado pelo gráfico com base no identificador, e uma vez identificado, calcula
 * o novo objeto de opções que será consumido pelo gráfico e retorna o mesmo.
 * @param {string} identifier Identificador do gráfico.
 * @param {object} options Opções que serão passadas por parâmetro para o echartOption resolvido.
 * @param {string} updateOnly Quando setado {color | data | fontSize} evitará todo o reprocessamento do cálculo do objeto
 * de configuração do gráfico. Por exemplo, se for setado como "color", apenas as cores do gráfico serão levadas em consideração
 * no cálculo do echartOption, e não será processado o cálculo das series ou das fontes.
 */
export function getEchartOptionByChartType(
  identifier,
  options = {},
  updateOnly,
) {

  const { 
    data,
    colors,
    chartFontSize,
    chartSize,
    disabledLegends = [],
    currentOptions = null,
    highlitIndex,
    ascOrder
  } = options;
  
  // Aplica a estratégia de atualização única
  if (currentOptions && updateOnly) {
    return updateOnlyStrategyResolver({ ...options, identifier }, updateOnly);
  }

  const echartOptionGetter = echartOptionStrategies[identifier];

  if (typeof echartOptionGetter === "function") {
    return echartOptionGetter(
      data,
      colors,
      chartFontSize,
      disabledLegends,
      chartSize,
      currentOptions,
      highlitIndex,
      ascOrder
    );
  }

  return null;
}
